var _style, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeypad = function SvgKeypad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "keypad_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".keypad_svg__st0{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 3.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 9.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 15.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 21.5,
    r: 2,
    className: "keypad_svg__st0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 15.5,
    r: 2,
    className: "keypad_svg__st0"
  })));
};
export default SvgKeypad;